import React, { useEffect, useState } from 'react';

const TradeTypesRender = ({ tradeTypes = [], candidateId }) => {

  const [displayPlusOne, setDisplayPlusOne] = useState(false);

  const div = document.querySelector('#profile-search-card-' + candidateId);
  const height = div?.offsetHeight;

  useEffect(() => {
    if (height > 74) {
      setDisplayPlusOne(true);
    }
  }, [height]);

  return (
    <div className="ptp-search-grid-item__experience-section-contents" id={`profile-search-card-${candidateId}`}>
      {tradeTypes?.map((type, idx) => (
        <div key={idx} className="ptp-search-grid-item__trades-section">
          <section>
            {type}
          </section>
        </div>
      ))}
      {displayPlusOne && <span className="ptp-search-grid-item__experience-section-plusOne">+1</span>}
    </div>
  );
};

export default TradeTypesRender;
